(function () {
  'use strict';

  if (!customElements.get('recipient-form')) {
    customElements.define('recipient-form', class RecipientForm extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.dataset.sectionId;

        this.checkbox = this.querySelector('#Recipient-Checkbox-' + this.sectionId);
        this.email = this.querySelector('#Recipient-email-' + this.sectionId);
        this.name = this.querySelector('#Recipient-name-' + this.sectionId);
        this.message = this.querySelector('#Recipient-message-' + this.sectionId);
        this.date = this.querySelector('#Recipient-send-on-' + this.sectionId);
        this.offset = this.querySelector('#Recipient-timezone-offset-' + this.sectionId);
        this.hiddenControl = this.querySelector('#Recipient-control-' + this.sectionId);
        if(this.hiddenControl)this.hiddenControl.disabled = true;

        if (!this.checkbox) return;

        this.checkbox.disabled = false;

        if (this.offset) {
          this.offset.value = new Date().getTimezoneOffset().toString();
        }

        this.checkbox.addEventListener('change', this.onToggle.bind(this));

        this.onToggle();
      }

      fields() {
        return [this.email, this.name, this.message, this.date];
      }

      disableableFields() {
        return this.fields().concat([this.offset]);
      }

      clearFields() {
        this.fields().forEach(function (f) {
          if (f) f.value = '';
        });
      }

      enableFields() {
        this.disableableFields().forEach(function (f) {
          if (f) f.disabled = false;
        });
      }

      disableFields() {
        this.disableableFields().forEach(function (f) {
          if (f) f.disabled = true;
        });
      }

      onToggle() {
        if (this.checkbox.checked) {
          this.enableFields();
        } else {
          this.clearFields();
          this.disableFields();
        }
      }

      resetForm() {
        if (this.checkbox.checked) {
          this.checkbox.checked = false;
          this.clearFields();
          this.disableFields();
        }
      }

      connectedCallback() {
        document.addEventListener('product:added', this.resetForm.bind(this));
      }
    });
  }

})();